import { useEffect, useState } from "react";
import { getConsent, setConsent } from "../lib/consent";
import {
  loadGoogleAnalytics,
  updateGoogleConsent,
} from "../lib/loadAnalytics";

export default function CookiePreferencesModal({ isOpen, onClose }) {
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    const consent = getConsent();
    setAnalytics(!!consent?.analytics);
    setMarketing(!!consent?.marketing);
  }, [isOpen]);

  if (!isOpen) return null;

  const savePreferences = () => {
    const consent = {
      essential: true,
      analytics,
      marketing,
    };

    setConsent(consent);

    if (analytics || marketing) {
      loadGoogleAnalytics();
    }

    updateGoogleConsent(consent);
    onClose();
  };

  const acceptAll = () => {
    const consent = {
      essential: true,
      analytics: true,
      marketing: true,
    };

    setAnalytics(true);
    setMarketing(true);
    setConsent(consent);
    loadGoogleAnalytics();
    updateGoogleConsent(consent);
    onClose();
  };

  const refuseAll = () => {
    const consent = {
      essential: true,
      analytics: false,
      marketing: false,
    };

    setAnalytics(false);
    setMarketing(false);
    setConsent(consent);
    updateGoogleConsent(consent);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-2xl rounded-2xl border border-[#E6E1D6] bg-[#FFFCF8] p-6 shadow-2xl">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-xl font-bold text-[#2A2A2A]">
              Préférences de cookies
            </h2>
            <p className="mt-2 text-sm text-[#5F5F5F]">
              Gérez ici les cookies utilisés sur le site. Les cookies essentiels
              sont toujours actifs car ils sont nécessaires au fonctionnement du site.
            </p>
          </div>

          <button
            onClick={onClose}
            className="rounded-lg px-3 py-1 text-sm text-[#5F5F5F] hover:bg-[#F5F1EA]"
            aria-label="Fermer"
          >
            ✕
          </button>
        </div>

        <div className="mt-6 space-y-4">
          <div className="rounded-xl border border-[#E6E1D6] p-4">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-semibold text-[#2A2A2A]">Cookies essentiels</h3>
                <p className="mt-1 text-sm text-[#5F5F5F]">
                  Nécessaires au fonctionnement du site. Ils ne peuvent pas être désactivés.
                </p>
              </div>

              <div className="rounded-full bg-[#EFE8DD] px-3 py-1 text-xs font-medium text-[#5F5F5F]">
                Toujours actifs
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-[#E6E1D6] p-4">
            <div className="flex items-start justify-between gap-4">
              <div className="pr-4">
                <h3 className="font-semibold text-[#2A2A2A]">Mesure d’audience</h3>
                <p className="mt-1 text-sm text-[#5F5F5F]">
                  Permettent de mesurer la fréquentation et l’utilisation du site,
                  par exemple avec Google Analytics.
                </p>
              </div>

              <label className="inline-flex cursor-pointer items-center">
                <input
                  type="checkbox"
                  checked={analytics}
                  onChange={(e) => setAnalytics(e.target.checked)}
                  className="h-5 w-5 rounded"
                />
              </label>
            </div>
          </div>

          <div className="rounded-xl border border-[#E6E1D6] p-4">
            <div className="flex items-start justify-between gap-4">
              <div className="pr-4">
                <h3 className="font-semibold text-[#2A2A2A]">Marketing</h3>
                <p className="mt-1 text-sm text-[#5F5F5F]">
                  Permettent de proposer des contenus, publicités ou suivis marketing
                  adaptés à votre navigation.
                </p>
              </div>

              <label className="inline-flex cursor-pointer items-center">
                <input
                  type="checkbox"
                  checked={marketing}
                  onChange={(e) => setMarketing(e.target.checked)}
                  className="h-5 w-5 rounded"
                />
              </label>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <button
            onClick={acceptAll}
            className="rounded-xl bg-[#2A2A2A] px-4 py-2 text-sm font-medium text-white hover:opacity-90"
          >
            Tout accepter
          </button>

          <button
            onClick={refuseAll}
            className="rounded-xl border border-[#D6CFC2] px-4 py-2 text-sm font-medium text-[#2A2A2A] hover:bg-[#F5F1EA]"
          >
            Tout refuser
          </button>

          <button
            onClick={savePreferences}
            className="rounded-xl border border-[#2A2A2A] px-4 py-2 text-sm font-medium text-[#2A2A2A] hover:bg-[#F0ECE5]"
          >
            Enregistrer mes choix
          </button>
        </div>
      </div>
    </div>
  );
}